import React,{useState, useEffect} from 'react'
import "./ImportFileformInputMatrix.css"
import download_template from '../../../assets/reUsableTemplates_assets/download_template.png';
import file_upload_icon from '../../../assets/reUsableTemplates_assets/file_upload_icon.png';
import file_uploaded_icon from '../../../assets/reUsableTemplates_assets/file_uploaded_icon.png';
import into from '../../../assets/reUsableTemplates_assets/into.png';
import branch_icon from "../../../assets/register_assets/inputMatix/branch_icon.png"
import current_month_icon from "../../../assets/register_assets/inputMatix/current_month_icon.png"
import { useDispatch } from 'react-redux';
import { getClients} from './../../../services/global_redux/globale_actions/Client.action';
import { getInputMatrixActivities } from './../../../services/register_redux/register_actions/Form.action';

function ImportFileformInputMatrix({filestemp, title, handleFileUpload ,setFiledata,date,File}) {
  const [file, setFile] = useState(null);
  const [dragActive, setDragActive] = useState(false);
  const selectedClient = sessionStorage.getItem('selectedClient');
  const [clientIDs, setClientIDs] = useState(null);
  const [totalBranchCount,setTotalBranchCount] = useState(0);
  const dispatch = useDispatch();
  const fetchAllClient = async () => {
    try {
        const response = await dispatch(getClients());
        if (response.data) {
              setClientIDs(response.data);
        }
    } catch (err) {
        console.error("Failed to fetch clients:", err);
    }
}

useEffect(() => {
        fetchAllClient();
  }, [dispatch]);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if(selectedFile === undefined){
      setFile(null);
      setFiledata(null);
      return;

    }else{
      if (!selectedFile.name.match(/\.(xls|xlsx)$/i)) {
        if(selectedFile !== undefined){
          alert("Only Excel files are allowed");
        }
        return;
      }else{
        setFiledata(selectedFile);
        setFile({
          name: selectedFile.name,
          size: (selectedFile.size / (1024 * 1024)).toFixed(2) + " MB",
        });
        e.target.value = "";
      }

    }
  };
  const removeFile = () => {
    setFile(null);
    setFiledata(null);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const droppedFile = e.dataTransfer.files[0];
      if (!droppedFile.name.match(/\.(xls|xlsx)$/i)) {
        alert("Only Excel files are allowed");
        return;
      }else{
        setFile(droppedFile);
      setFiledata(droppedFile);
        setFile({
          name: droppedFile.name,
          size: (droppedFile.size / (1024 * 1024)).toFixed(2) + " MB",
        });
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault(); 
    if (!file) {
      alert("no file");
      return;
    }else{
      handleFileUpload()
    }
  };
  useEffect(()=>{
    if(File === null){
      setFile(File);
    }
  },[File]) 
  
  const getInputMatrixActivitiesFetch = async () => {
    try {
      const response = await dispatch(getInputMatrixActivities());
      if (response.success === true) {
        setTotalBranchCount(response.data.total_unit_count);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
  
  useEffect(() => {
    getInputMatrixActivitiesFetch();
  }, [dispatch]);
  return (
    
    <div className="container-fluid FormsImportFile-main-inputMatrix ">
        <div className="row">
            <div className="col-md-5">
                <div className="col-md-12">
                    <div className="uploadFormsClientData">
                        <div className="uploadFormsClientDataTitle">
                            <h5>{clientIDs?.find(client => client.client_id === selectedClient)?.client_name}</h5>
                            <p>Org. ID : {selectedClient}</p>
                        </div>
                        <div className="uploadFormsClientDataMonth d-flex gap-3">
                            <div className="d-flex align-items-center gap-2">
                                
                                <div>
                                    <h6><img src={branch_icon} alt="Branch Icon" className="info-icon" />Branch</h6>
                                    <p className='branch_data dataBorderDesign'>{totalBranchCount}</p>
                                </div>
                            </div>
                            <div className="vertical_line"></div>
                            <div className="d-flex align-items-center gap-2">
                                
                                <div>
                                    <h6><img src={branch_icon} alt="Branch Icon" className="info-icon" />current Month</h6>
                                    {/* {useMonths ?? <p className='current_month_data dataBorderDesign'>{new Date(useMonths)}</p>} */}
                                    <button className='current_month_data dataBorderDesign'>{date ?  new Date(date).toLocaleString('default', { month: 'long', year: 'numeric' }) : 'No Data Available'}</button>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

            </div>
            <div  className="col-md-7">
            <div className="col-md-12">
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-md-12 d-flex FormsImportFile-title-inputMatrix">
                        <div className="col ">
                        <h5>Import {title}</h5>
                        <p className='p-0 m-0'>Add your documents here</p>
                        </div>
                        
                        
                        <div className="col"><button className="upload-file-submit-btn float-end">Submit</button><a href={filestemp} download={ title === "Org. Details" ? "Org_Details":title} className='float-end template-btn me-2'><img src={download_template} alt="" /><span>Template</span></a></div>

                    </div>
                </div>
    
                <div className="row FormsImportFile-upload-inputMatrix">
                    <div className="upload-box-main-inputMatrix ">
                    <div
                        className={`upload-box d-flex align-items-center justify-content-between ${
                        dragActive ? "drag-active" : ""
                        }`}
                        onDragOver={(e) => {
                        e.preventDefault();
                        setDragActive(true);
                        }}
                        onDragLeave={() => setDragActive(false)}
                        onDrop={handleDrop}
                    >
                        <div className="d-flex align-items-center">
                        <div className="upload-icon me-2">
                            <img src={file_upload_icon} alt="no img" />
                        </div>
                        <div>
                            <p className="p-0 m-0">
                            {dragActive ? "Drop file here" : "Select a file or drag and drop here"}
                            </p>
                            <small className="text-muted">
                            Only supports .xlsx
                            </small>
                        </div>
                        </div>
                        <a
                        onClick={() => document.getElementById("fileInput").click()}
                        >
                        SELECT FILE
                        </a>
                        <input
                        type="file"
                        id="fileInput"
                        className="d-none"
                        onChange={handleFileChange}
                        accept=".xls,.xlsx"
                        />
                    </div>
                    </div>

                    {file && (
                    <div className="uploaded-box-main-inputMatrix p-0 m-0">
                        <div className="uploaded-file d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                            <img src={file_uploaded_icon} alt="no img" />
                            <div>
                            <p className="mb-0 uploaded-file-name">{file.name}</p>
                            <small className="text-muted uploaded-file-size">{file.size}</small>
                            </div>
                        </div>
                        <a
                            className="close-btn p-0"
                            onClick={removeFile}
                        >
                            <img src={into} alt="noImg" />
                        </a>
                        </div>
                    </div>
                    )}
                </div>
            </form>
            </div>
        </div>
        </div>
    </div>
  )
}

export default ImportFileformInputMatrix